import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import Button from "../../../../shared/button/Button";
import {
  ButtonsWrapper,
  ActionConfirmation,
  CloseButton,
  ActionConfimationIcon,
  ActionConfirmationMessage,
  Divider,
} from "../styles/action-confirmation-styles";

const RejectActionConfirmation = ({
  handleActionConfirmation,
  handleCancelRecruiterConfirmation,
}) => (
  <ActionConfirmation>
    <CloseButton onClick={(e) => handleCancelRecruiterConfirmation(e)}>
      <FontAwesomeIcon icon={faTimes} />
    </CloseButton>
    <ActionConfimationIcon className="animated bounceIn delay-2">
      <FontAwesomeIcon icon={faQuestionCircle} />
    </ActionConfimationIcon>
    <ActionConfirmationMessage className="animated fadeInUp delay-3">
      What do you want to do?{" "}
    </ActionConfirmationMessage>
    <ButtonsWrapper>
      <Button
        primary
        buttonName="Accept Job Offer"
        onClickAction={() => handleActionConfirmation("accept")}
        classes="animated fadeInUp delay-4"
      />
      <Divider className="animated fadeInUp delay-5">or</Divider>
      <Button
        secondary
        buttonName="Reject Job Offer"
        onClickAction={() => handleActionConfirmation("reject")}
        classes="animated fadeInUp delay-5"
      />
    </ButtonsWrapper>
  </ActionConfirmation>
);

RejectActionConfirmation.propTypes = {
  handleActionConfirmation: PropTypes.func.isRequired,
  handleCancelRecruiterConfirmation: PropTypes.func.isRequired,
};

export default RejectActionConfirmation;
